import React, { useEffect, useState } from "react";
import axios from "axios";
import { getHeaders } from "../../utility/getHeader";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import CardComponent from "../../components/cards/CardComponent";
import Layout from "../../layout/Layout";

import { TextfieldwithLabel } from "../../components/Buttons/Textfield";
import fetchData from "../../functions/fetchData";
import "../../styles/suppliers.css";

export default function Suppliers() {
  const [data, setData] = useState([]);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showAddModal, setShowAddModal] = useState(false);
  const [selectedSupplier, setSelectedSupplier] = useState(null);
  const [editFormData, setEditFormData] = useState({
    supplier_name: "",
    contact_person: "",
    phone: "",
    email: "",
    address: "",
    city: "",
    state: "",
    country: "Thailand",
    postal_code: "",
    tax_id: "",
    credit_limit: "",
    payment_terms: "",
    notes: "",
  });
  const [formdata, setFormData] = useState({
    supplier_name: "",
    contact_person: "",
    phone: "",
    email: "",
    address: "",
    city: "",
    state: "",
    country: "Thailand",
    postal_code: "",
    tax_id: "",
    credit_limit: "",
    payment_terms: "",
    notes: "",
    opening_balance: "",
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleEditInputChange = (e) => {
    const { name, value } = e.target;
    setEditFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    console.log('Form Data before submission:', formdata);

    const loadingToast = toast.loading("Adding supplier...");

    try {
      // First, save the supplier
      const supplierResponse = await axios.post(
        "/insertdata/suppliers",
        {
          supplier_name: formdata.supplier_name,
          contact_person: formdata.contact_person,
          phone: formdata.phone,
          email: formdata.email,
          address: formdata.address,
          city: formdata.city,
          state: formdata.state,
          country: formdata.country,
          postal_code: formdata.postal_code,
          tax_id: formdata.tax_id,
          credit_limit: parseFloat(formdata.credit_limit) || 0.00,
          payment_terms: formdata.payment_terms,
          notes: formdata.notes,
          is_active: 1
        },
        getHeaders()
      );

      console.log('Supplier Response:', supplierResponse.data);

      // Handle opening balance if provided
      const openingBalance = parseFloat(formdata.opening_balance) || 0;
      console.log('Opening Balance:', openingBalance);
      
      if (openingBalance > 0) {
        const supplierId = supplierResponse.data?.id;
        
        console.log('Supplier ID for ledger:', supplierId);
        
        if (supplierId) {
          const transactionId = `OPENING_SUP_${supplierId}_${Date.now()}`;
          
          console.log('Creating supplier ledger entry with:', {
            transaction_id: transactionId,
            supplier_id: supplierId,
            credit_amount: openingBalance
          });
          
          await axios.post(
            "/insertdata/supplier_ledger_entries",
            {
              transaction_id: transactionId,
              date: new Date().toISOString(),
              account_type: "Account Payable",
              supplier_id: supplierId,
              description: `Opening Balance for Supplier: ${formdata.supplier_name}`,
              debit_amount: 0.00,
              credit_amount: openingBalance,
              reference_id: supplierId
            },
            getHeaders()
          );
          console.log('✅ Supplier ledger entry created successfully');
        } else {
          console.error('Supplier ID not found in response:', supplierResponse.data);
          toast.warning('⚠️ Supplier saved but opening balance could not be recorded');
        }
      }

      // Fetch updated data
      await fetchData("suppliers", setData, "id", {});

      // Success toast
      toast.success(`🎉 Supplier "${formdata.supplier_name}" added successfully!${openingBalance > 0 ? ` Opening balance of ฿${openingBalance.toLocaleString()} recorded.` : ''}`);
      toast.dismiss(loadingToast);

      // Reset form
      setFormData({
        supplier_name: "",
        contact_person: "",
        phone: "",
        email: "",
        address: "",
        city: "",
        state: "",
        country: "Thailand",
        postal_code: "",
        tax_id: "",
        credit_limit: "",
        payment_terms: "",
        notes: "",
        opening_balance: "",
      });
      setShowAddModal(false); // Close modal after successful submission
    } catch (err) {
      toast.dismiss(loadingToast);
      toast.error(`❌ Failed to add supplier: ${err.response?.data?.message || err.message}`);
      console.error(err.message);
    }
  };

  // Handle edit button click
  const handleEdit = (supplier) => {
    setSelectedSupplier(supplier);
    setEditFormData({
      supplier_name: supplier.supplier_name || "",
      contact_person: supplier.contact_person || "",
      phone: supplier.phone || "",
      email: supplier.email || "",
      address: supplier.address || "",
      city: supplier.city || "",
      state: supplier.state || "",
      country: supplier.country || "Thailand",
      postal_code: supplier.postal_code || "",
      tax_id: supplier.tax_id || "",
      credit_limit: supplier.credit_limit || "",
      payment_terms: supplier.payment_terms || "",
      notes: supplier.notes || "",
    });
    setShowEditModal(true);
  };

  // Handle update submit
  const handleUpdateSubmit = async (e) => {
    e.preventDefault();
    
    if (!selectedSupplier) return;
    
    const loadingToast = toast.loading("Updating supplier...");
    
    try {
      await axios.put(
        `/updatecommondata/suppliers/id/${selectedSupplier.id}`,
        {
          supplier_name: editFormData.supplier_name,
          contact_person: editFormData.contact_person,
          phone: editFormData.phone,
          email: editFormData.email,
          address: editFormData.address,
          city: editFormData.city,
          state: editFormData.state,
          country: editFormData.country,
          postal_code: editFormData.postal_code,
          tax_id: editFormData.tax_id,
          credit_limit: parseFloat(editFormData.credit_limit) || 0.00,
          payment_terms: editFormData.payment_terms,
          notes: editFormData.notes,
        },
        getHeaders()
      );

      await fetchData("suppliers", setData, "id", {});
      
      toast.success(`✅ Supplier "${editFormData.supplier_name}" updated successfully!`);
      toast.dismiss(loadingToast);
      setShowEditModal(false);
      setSelectedSupplier(null);
      setEditFormData({
        supplier_name: "",
        contact_person: "",
        phone: "",
        email: "",
        address: "",
        city: "",
        state: "",
        country: "Thailand",
        postal_code: "",
        tax_id: "",
        credit_limit: "",
        payment_terms: "",
        notes: "",
      });
    } catch (err) {
      toast.dismiss(loadingToast);
      toast.error(`❌ Failed to update supplier: ${err.response?.data?.message || err.message}`);
      console.error(err.message);
    }
  };

  // Handle delete
  const handleDelete = async (supplierId, supplierName) => {
    if (window.confirm(`Are you sure you want to delete supplier "${supplierName}"?`)) {
      const loadingToast = toast.loading("Deleting supplier...");
      try {
        await axios.delete(
          `/deletebyid/suppliers/id/${supplierId}`,
          getHeaders()
        );
        
        await fetchData("suppliers", setData, "id", {});
        toast.success(`🗑️ Supplier "${supplierName}" deleted successfully!`);
        toast.dismiss(loadingToast);
      } catch (err) {
        toast.dismiss(loadingToast);
        toast.error(`❌ Failed to delete supplier: ${err.response?.data?.message || err.message}`);
        console.error(err.message);
      }
    }
  };

  useEffect(() => {
    const fetchAndSetData = async () => {
      try {
        await fetchData("suppliers", setData, "id", {});
      } catch (error) {
        console.error("Error in useEffect:", error);
      }
    };

    fetchAndSetData();
  }, []);
  return (
    <>
      <Layout>
        <div className="supplier-container">
          <div className="container-fluid">
            {/* Header Section */}
            <div className="supplier-header fade-in">
              <h1>
                <i className="fa fa-truck card-icon"></i>
                Supplier Management System
              </h1>
              <button 
                className="add-supplier-btn"
                onClick={() => setShowAddModal(true)}
              >
                <i className="fa fa-plus me-2"></i>
                Add New Supplier
              </button>
            </div>

            <ToastContainer />
            
            <div className="row">
              {/* Supplier List - Full Width */}
              <div className="col-12">
            <CardComponent
              title="Supplier List"
              headerColor="lightblue"
              pull="left"
              bodyClass="panel-body"
            >
              {data.length === 0 ? (
                <div className="text-center p-4" style={{ backgroundColor: '#f8f9fc', borderRadius: '10px', border: '1px solid #e3e8f0' }}>
                  <div style={{ padding: '20px' }}>
                    <i className="fa fa-truck fa-3x text-muted mb-3" style={{ color: '#a8b5c8' }}></i>
                    <h6 style={{ color: '#5a6c7d', fontWeight: '600', marginBottom: '8px' }}>No Suppliers Available</h6>
                    <p className="text-muted mb-0" style={{ fontSize: '14px', color: '#8b95a5' }}>Add your first supplier to get started with vendor management</p>
                  </div>
                </div>
              ) : (
                <div style={{ backgroundColor: '#ffffff', borderRadius: '10px', overflow: 'hidden', boxShadow: '0 2px 10px rgba(0,0,0,0.08)' }}>
                  <div className="table-responsive">
                    <table className="table table-hover mb-0" style={{ fontSize: '13px' }}>
                      <thead style={{ backgroundColor: '#f8f9fc', borderBottom: '2px solid #e3e8f0' }}>
                        <tr>
                          <th scope="col" style={{ padding: '12px 8px', fontWeight: '600', color: '#5a6c7d', fontSize: '12px' }}>
                            #
                          </th>
                          <th scope="col" style={{ padding: '12px 8px', fontWeight: '600', color: '#5a6c7d', fontSize: '12px' }}>
                            <i className="fa fa-building me-1"></i>Supplier
                          </th>
                          <th scope="col" style={{ padding: '12px 8px', fontWeight: '600', color: '#5a6c7d', fontSize: '12px' }}>
                            <i className="fa fa-user me-1"></i>Contact
                          </th>
                          <th scope="col" style={{ padding: '12px 8px', fontWeight: '600', color: '#5a6c7d', fontSize: '12px' }}>
                            <i className="fa fa-phone me-1"></i>Phone
                          </th>
                          <th scope="col" style={{ padding: '12px 8px', fontWeight: '600', color: '#5a6c7d', fontSize: '12px' }}>
                            <i className="fa fa-envelope me-1"></i>Email
                          </th>
                          <th scope="col" style={{ padding: '12px 8px', fontWeight: '600', color: '#5a6c7d', fontSize: '12px' }}>
                            <i className="fa fa-map-marker-alt me-1"></i>Location
                          </th>
                          <th scope="col" style={{ padding: '12px 8px', fontWeight: '600', color: '#5a6c7d', fontSize: '12px' }}>
                            <i className="fa fa-credit-card me-1"></i>Credit
                          </th>
                          <th scope="col" style={{ padding: '12px 8px', fontWeight: '600', color: '#5a6c7d', fontSize: '12px', textAlign: 'center' }}>
                            <i className="fa fa-toggle-on me-1"></i>Status
                          </th>
                          <th scope="col" className="text-center" style={{ padding: '12px 8px', fontWeight: '600', color: '#5a6c7d', fontSize: '12px' }}>
                            <i className="fa fa-cogs me-1"></i>Actions
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {data.map((supplier, index) => (
                          <tr key={supplier.id} style={{ borderBottom: '1px solid #f1f3f6' }}>
                            <th scope="row" style={{ padding: '12px 8px', color: '#8b95a5', fontSize: '12px', fontWeight: '500' }}>
                              {index + 1}
                            </th>
                            <td style={{ padding: '12px 8px' }}>
                              <div>
                                <div style={{ fontWeight: '600', color: '#2c3e50', fontSize: '13px', marginBottom: '2px' }}>
                                  {supplier.supplier_name}
                                </div>
                                <small style={{ color: '#8b95a5', fontSize: '11px' }}>ID: #{supplier.id}</small>
                              </div>
                            </td>
                            <td style={{ padding: '12px 8px' }}>
                              {supplier.contact_person ? (
                                <span style={{ color: '#2c3e50', fontSize: '13px' }}>{supplier.contact_person}</span>
                              ) : (
                                <span style={{ color: '#bdc3c7', fontSize: '12px', fontStyle: 'italic' }}>-</span>
                              )}
                            </td>
                            <td style={{ padding: '12px 8px' }}>
                              {supplier.phone ? (
                                <span style={{ color: '#2c3e50', fontSize: '13px' }}>{supplier.phone}</span>
                              ) : (
                                <span style={{ color: '#bdc3c7', fontSize: '12px', fontStyle: 'italic' }}>-</span>
                              )}
                            </td>
                            <td style={{ padding: '12px 8px' }}>
                              {supplier.email ? (
                                <span style={{ color: '#3498db', fontSize: '13px' }}>{supplier.email}</span>
                              ) : (
                                <span style={{ color: '#bdc3c7', fontSize: '12px', fontStyle: 'italic' }}>-</span>
                              )}
                            </td>
                            <td style={{ padding: '12px 8px' }}>
                              <div>
                                {supplier.city && (
                                  <div style={{ fontSize: '12px', color: '#2c3e50' }}>{supplier.city}</div>
                                )}
                                {supplier.country && (
                                  <small style={{ fontSize: '11px', color: '#8b95a5' }}>{supplier.country}</small>
                                )}
                                {!supplier.city && !supplier.country && (
                                  <span style={{ color: '#bdc3c7', fontSize: '12px', fontStyle: 'italic' }}>-</span>
                                )}
                              </div>
                            </td>
                            <td style={{ padding: '12px 8px' }}>
                              {supplier.credit_limit > 0 ? (
                                <span style={{ 
                                  backgroundColor: '#e8f5e8', 
                                  color: '#27ae60', 
                                  padding: '2px 6px', 
                                  borderRadius: '12px', 
                                  fontSize: '11px',
                                  fontWeight: '500'
                                }}>
                                  ฿{parseFloat(supplier.credit_limit).toLocaleString()}
                                </span>
                              ) : (
                                <span style={{ color: '#bdc3c7', fontSize: '12px', fontStyle: 'italic' }}>No limit</span>
                              )}
                            </td>
                            <td className="text-center" style={{ padding: '12px 8px' }}>
                              {supplier.is_active ? (
                                <span style={{ 
                                  backgroundColor: '#e8f5e8', 
                                  color: '#27ae60', 
                                  padding: '3px 8px', 
                                  borderRadius: '12px', 
                                  fontSize: '11px',
                                  fontWeight: '500'
                                }}>
                                  Active
                                </span>
                              ) : (
                                <span style={{ 
                                  backgroundColor: '#fee', 
                                  color: '#e74c3c', 
                                  padding: '3px 8px', 
                                  borderRadius: '12px', 
                                  fontSize: '11px',
                                  fontWeight: '500'
                                }}>
                                  Inactive
                                </span>
                              )}
                            </td>
                            <td className="text-center" style={{ padding: '12px 8px' }}>
                              <div className="btn-group" role="group">
                                <button
                                  className="btn btn-sm"
                                  onClick={() => handleEdit(supplier)}
                                  title="Edit Supplier"
                                  style={{
                                    backgroundColor: '#3498db',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '4px',
                                    padding: '4px 8px',
                                    marginRight: '4px',
                                    fontSize: '11px'
                                  }}
                                >
                                  <i className="fa fa-edit"></i>
                                </button>
                                <button
                                  className="btn btn-sm"
                                  onClick={() => handleDelete(supplier.id, supplier.supplier_name)}
                                  title="Delete Supplier"
                                  style={{
                                    backgroundColor: '#e74c3c',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '4px',
                                    padding: '4px 8px',
                                    fontSize: '11px'
                                  }}
                                >
                                  <i className="fa fa-trash"></i>
                                </button>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                  
                  {/* Table Summary */}
                  <div style={{ 
                    padding: '15px 20px', 
                    backgroundColor: '#f8f9fc', 
                    borderTop: '1px solid #e3e8f0',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center'
                  }}>
                    <div>
                      <small style={{ color: '#8b95a5', fontSize: '12px' }}>
                        <i className="fa fa-info-circle me-1"></i>
                        Showing {data.length} supplier{data.length !== 1 ? 's' : ''}
                      </small>
                    </div>
                    <div>
                      <small style={{ color: '#8b95a5', fontSize: '12px' }}>
                        <i className="fa fa-calendar me-1"></i>
                        Updated: {new Date().toLocaleDateString()}
                      </small>
                    </div>
                  </div>
                </div>
              )}
            </CardComponent>
          </div>
        </div>
        
          </div>
        </div>
        
        {/* Add Supplier Modal */}
        {showAddModal && (
          <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}>
            <div className="modal-dialog modal-xl">
              <div className="modal-content">
                <div className="modal-header" style={{ background: 'linear-gradient(135deg, #2196f3 0%, #21cbf3 100%)', color: 'white' }}>
                  <h5 className="modal-title">
                    <i className="fa fa-plus-circle me-2"></i>
                    Add New Supplier
                  </h5>
                  <button
                    type="button"
                    className="btn-close btn-close-white"
                    onClick={() => setShowAddModal(false)}
                  ></button>
                </div>
                <div className="modal-body">
                  <form onSubmit={handleSubmit}>
                    {/* Basic Information */}
                    <div className="form-section">
                      <div className="section-title">
                        <i className="fa fa-building"></i>
                        Basic Information
                      </div>
                      <div className="row g-3">
                        <div className="col-md-6">
                          <label className="form-label">Supplier Name *</label>
                          <input
                            id="supplier_name"
                            name="supplier_name"
                            value={formdata.supplier_name}
                            onChange={handleInputChange}
                            type="text"
                            className="form-control"
                            placeholder="Enter supplier name"
                            required
                          />
                        </div>
                        <div className="col-md-6">
                          <label className="form-label">Contact Person</label>
                          <input
                            id="contact_person"
                            name="contact_person"
                            value={formdata.contact_person}
                            onChange={handleInputChange}
                            type="text"
                            className="form-control"
                            placeholder="Contact person name"
                          />
                        </div>
                        <div className="col-md-6">
                          <label className="form-label">Phone</label>
                          <input
                            id="phone"
                            name="phone"
                            value={formdata.phone}
                            onChange={handleInputChange}
                            type="tel"
                            className="form-control"
                            placeholder="Phone number"
                          />
                        </div>
                        <div className="col-md-6">
                          <label className="form-label">Email</label>
                          <input
                            id="email"
                            name="email"
                            value={formdata.email}
                            onChange={handleInputChange}
                            type="email"
                            className="form-control"
                            placeholder="Email address"
                          />
                        </div>
                      </div>
                    </div>

                    {/* Contact Information */}
                    <div className="form-section">
                      <div className="section-title">
                        <i className="fa fa-map-marker-alt"></i>
                        Address Information
                      </div>
                      <div className="row g-3">
                        <div className="col-12">
                          <label className="form-label">Address</label>
                          <textarea
                            id="address"
                            name="address"
                            value={formdata.address}
                            onChange={handleInputChange}
                            className="form-control"
                            rows="3"
                            placeholder="Complete address"
                          />
                        </div>
                        <div className="col-md-6">
                          <label className="form-label">City</label>
                          <input
                            id="city"
                            name="city"
                            value={formdata.city}
                            onChange={handleInputChange}
                            type="text"
                            className="form-control"
                            placeholder="City"
                          />
                        </div>
                        <div className="col-md-6">
                          <label className="form-label">State/Province</label>
                          <input
                            id="state"
                            name="state"
                            value={formdata.state}
                            onChange={handleInputChange}
                            type="text"
                            className="form-control"
                            placeholder="State or Province"
                          />
                        </div>
                        <div className="col-md-6">
                          <label className="form-label">Country</label>
                          <input
                            id="country"
                            name="country"
                            value={formdata.country}
                            onChange={handleInputChange}
                            type="text"
                            className="form-control"
                            placeholder="Country"
                          />
                        </div>
                        <div className="col-md-6">
                          <label className="form-label">Postal Code</label>
                          <input
                            id="postal_code"
                            name="postal_code"
                            value={formdata.postal_code}
                            onChange={handleInputChange}
                            type="text"
                            className="form-control"
                            placeholder="Postal code"
                          />
                        </div>
                      </div>
                    </div>

                    {/* Business Information */}
                    <div className="form-section">
                      <div className="section-title">
                        <i className="fa fa-briefcase"></i>
                        Business Information
                      </div>
                      <div className="row g-3">
                        <div className="col-md-6">
                          <label className="form-label">Tax ID</label>
                          <input
                            id="tax_id"
                            name="tax_id"
                            value={formdata.tax_id}
                            onChange={handleInputChange}
                            type="text"
                            className="form-control"
                            placeholder="Tax identification number"
                          />
                        </div>
                        <div className="col-md-6">
                          <label className="form-label">Credit Limit (฿)</label>
                          <input
                            id="credit_limit"
                            name="credit_limit"
                            value={formdata.credit_limit}
                            onChange={handleInputChange}
                            type="number"
                            step="0.01"
                            className="form-control"
                            placeholder="0.00"
                          />
                        </div>
                        <div className="col-md-6">
                          <label className="form-label">Payment Terms</label>
                          <input
                            id="payment_terms"
                            name="payment_terms"
                            value={formdata.payment_terms}
                            onChange={handleInputChange}
                            type="text"
                            className="form-control"
                            placeholder="e.g., Net 30 days"
                          />
                        </div>
                        <div className="col-md-6">
                          <label className="form-label">Opening Balance (฿)</label>
                          <input
                            id="opening_balance"
                            name="opening_balance"
                            value={formdata.opening_balance}
                            onChange={handleInputChange}
                            type="number"
                            step="0.01"
                            className="form-control"
                            placeholder="0.00"
                          />
                        </div>
                        <div className="col-12">
                          <label className="form-label">Notes</label>
                          <textarea
                            id="notes"
                            name="notes"
                            value={formdata.notes}
                            onChange={handleInputChange}
                            className="form-control"
                            rows="3"
                            placeholder="Additional notes about the supplier..."
                          />
                        </div>
                      </div>
                    </div>

                    <div className="modal-footer">
                      <button
                        type="button"
                        className="btn btn-secondary"
                        onClick={() => setShowAddModal(false)}
                      >
                        <i className="fa fa-times me-1"></i>Cancel
                      </button>
                      <button type="submit" className="btn btn-primary">
                        <i className="fa fa-save me-1"></i>Add Supplier
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        )}
        
        {/* Edit Supplier Modal */}
        {showEditModal && (
          <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}>
            <div className="modal-dialog modal-lg">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">
                    <i className="fa fa-edit me-2"></i>Edit Supplier
                  </h5>
                  <button 
                    type="button" 
                    className="btn-close" 
                    onClick={() => setShowEditModal(false)}
                  ></button>
                </div>
                <div className="modal-body">
                  <form onSubmit={handleUpdateSubmit}>
                    <div className="row g-3">
                      <div className="col-md-6">
                        <TextfieldwithLabel
                          id="edit_supplier_name"
                          onChange={handleEditInputChange}
                          value={editFormData.supplier_name}
                          type="text"
                          name="supplier_name"
                          lable="Supplier Name"
                        />
                      </div>
                      <div className="col-md-6">
                        <TextfieldwithLabel
                          id="edit_contact_person"
                          onChange={handleEditInputChange}
                          value={editFormData.contact_person}
                          type="text"
                          name="contact_person"
                          lable="Contact Person"
                        />
                      </div>
                      <div className="col-md-6">
                        <TextfieldwithLabel
                          id="edit_phone"
                          onChange={handleEditInputChange}
                          value={editFormData.phone}
                          type="tel"
                          name="phone"
                          lable="Phone"
                        />
                      </div>
                      <div className="col-md-6">
                        <TextfieldwithLabel
                          id="edit_email"
                          onChange={handleEditInputChange}
                          value={editFormData.email}
                          type="email"
                          name="email"
                          lable="Email"
                        />
                      </div>
                      <div className="col-md-12">
                        <TextfieldwithLabel
                          id="edit_address"
                          onChange={handleEditInputChange}
                          value={editFormData.address}
                          type="text"
                          name="address"
                          lable="Address"
                        />
                      </div>
                      <div className="col-md-4">
                        <TextfieldwithLabel
                          id="edit_city"
                          onChange={handleEditInputChange}
                          value={editFormData.city}
                          type="text"
                          name="city"
                          lable="City"
                        />
                      </div>
                      <div className="col-md-4">
                        <TextfieldwithLabel
                          id="edit_country"
                          onChange={handleEditInputChange}
                          value={editFormData.country}
                          type="text"
                          name="country"
                          lable="Country"
                        />
                      </div>
                      <div className="col-md-4">
                        <TextfieldwithLabel
                          id="edit_tax_id"
                          onChange={handleEditInputChange}
                          value={editFormData.tax_id}
                          type="text"
                          name="tax_id"
                          lable="Tax ID"
                        />
                      </div>
                      <div className="col-md-6">
                        <TextfieldwithLabel
                          id="edit_credit_limit"
                          onChange={handleEditInputChange}
                          value={editFormData.credit_limit}
                          type="number"
                          step="0.01"
                          name="credit_limit"
                          lable="Credit Limit (฿)"
                        />
                      </div>
                      <div className="col-md-6">
                        <TextfieldwithLabel
                          id="edit_payment_terms"
                          onChange={handleEditInputChange}
                          value={editFormData.payment_terms}
                          type="text"
                          name="payment_terms"
                          lable="Payment Terms"
                        />
                      </div>
                      <div className="col-md-12">
                        <div className="form-group">
                          <label className="control-label">Notes</label>
                          <textarea
                            id="edit_notes"
                            name="notes"
                            value={editFormData.notes}
                            onChange={handleEditInputChange}
                            className="form-control"
                            rows="3"
                            placeholder="Additional notes..."
                          />
                        </div>
                      </div>
                    </div>
                    <div className="modal-footer">
                      <button 
                        type="button" 
                        className="btn btn-secondary" 
                        onClick={() => setShowEditModal(false)}
                      >
                        <i className="fa fa-times me-1"></i>Cancel
                      </button>
                      <button type="submit" className="btn btn-primary">
                        <i className="fa fa-save me-1"></i>Update Supplier
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        )}
        
      </Layout>
    </>
  );
}
